import { add } from "@dnd-kit/utilities";

export const baseURL = 'https://api.educonnekt.in';
export const apiURL = `${baseURL}/admin`;

export const documentBaseURL = `${baseURL}/documents`;
export const profileImageBaseURL = `${baseURL}/profile-images`;
export const libraryBookImageBaseURL = `${baseURL}/library-books`;

export const getApiEndpoints = () => {
    return {
        // Public
        register: `${apiURL}/api/institutions/register.php`,

        // Auth 
        login: `${apiURL}/auth/login.php`,
        sendOtp: `${apiURL}/auth/send-mail-otp.php`,
        checkAuth: `${apiURL}/auth/check-auth.php`,
        refreshToken: `${apiURL}/auth/refresh-token.php`,
        logout: `${apiURL}/auth/logout.php`,

        // State & Cities 
        createCity: `${apiURL}/api/state-cities/create.php`,
        fetchStatesCities: `${apiURL}/api/state-cities/list.php`,
        updateCityName: `${apiURL}/api/state-cities/city-update.php`,
        deleteStatesCities: `${apiURL}/api/state-cities/delete-state-city.php`,
        fetchCitiesStatewise: `${apiURL}/api/state-cities/city-list.php`,

        // Institutions 
        addInstitution: `${apiURL}/api/institutions/insert.php`,
        fetchInstitutions: `${apiURL}/api/institutions/list.php`,
        fetchAllUsers: `${apiURL}/api/institutions/user-list.php`,

        // Coupons 
        createCoupon: `${apiURL}/api/coupons/create.php`,
        fetchCoupons: `${apiURL}/api/coupons/list.php`,
        deleteCoupon: `${apiURL}/api/coupons/delete.php`,
        fetchCouponDetails: `${apiURL}/api/coupons/details.php`,

        // Sessions 
        createSession: `${apiURL}/api/institutions/sessions/create.php`,
        fetchSessions: `${apiURL}/api/institutions/sessions/list.php`,

        // Academic 
        createAcademicLevel: `${apiURL}/api/institutions/academic/academic-level/create.php`,
        fetchAcademicLevels: `${apiURL}/api/institutions/academic/academic-level/list.php`,

        // Time Slots 
        createTimeSlot: `${apiURL}/api/institutions/time-slot/create.php`,
        fetchTimeSlots: `${apiURL}/api/institutions/time-slot/list.php`,

        // ====================== Students ======================
        studentUploadForm: `${apiURL}/api/student/form.php`,
        addStudent: `${apiURL}/api/student/create.php`,
        fetchStudents: `${apiURL}/api/student/list.php`,

        // Form Sections 
        createStudentFormSection: `${apiURL}/api/student/sections/create.php`,
        deleteStudentFormSection: `${apiURL}/api/student/sections/delete.php`,
        fetchStudentFormSection: `${apiURL}/api/student/sections/list.php`,

        // Form Fields
        createStudentFormFields: `${apiURL}/api/student/fields/create.php`,
        deleteStudentFormField: `${apiURL}/api/student/fields/delete.php`,
        fetchStudentFormFields: `${apiURL}/api/student/fields/list.php`,
        updateStudentFormFieldOrder: `${apiURL}/api/student/fields/update-order.php`,
        
        // ====================== Staffs ======================
        staffUploadForm: `${apiURL}/api/staff/form.php`,
        addStaff: `${apiURL}/api/staff/create.php`,
        fetchStaffs: `${apiURL}/api/staff/list.php`,
        fetchTeachers: `${apiURL}/api/staff/teacher-list.php`,

        // Form Sections 
        createStaffFormSection: `${apiURL}/api/staff/sections/create.php`,
        deleteStaffFormSection: `${apiURL}/api/staff/sections/delete.php`,
        fetchStaffFormSection: `${apiURL}/api/staff/sections/list.php`,
        
        // Form Fields
        createStaffFormFields: `${apiURL}/api/staff/fields/create.php`,
        deleteStaffFormField: `${apiURL}/api/staff/fields/delete.php`,
        fetchStaffFormFields: `${apiURL}/api/staff/fields/list.php`,
        updateStaffFormFieldOrder: `${apiURL}/api/staff/fields/update-order.php`,

        // Subjects 
        createSubject: `${apiURL}/api/institutions/subjects/create.php`,
        fetchSubjects: `${apiURL}/api/institutions/subjects/list.php`,
        addSubjectClassWise: `${apiURL}/api/institutions/academic/class/add-subject.php`,

        // Class & Section 
        createClass: `${apiURL}/api/institutions/academic/class/create.php`,
        fetchClasses: `${apiURL}/api/institutions/academic/class/list.php`,
        createSection: `${apiURL}/api/institutions/academic/section/create.php`,
        deleteSection: `${apiURL}/api/institutions/academic/section/delete.php`,
        fetchClassSections: `${apiURL}/api/institutions/academic/section/list.php`,
        classSectionDetails: `${apiURL}/api/institutions/academic/section/details.php`,
        editClassSectionTeacher: `${apiURL}/api/institutions/academic/section/edit-teacher.php`,

        // Time Table 
        generateTimeTable: `${apiURL}/api/time-table/generate.php`,
        fetchTimeTable: `${apiURL}/api/time-table/list.php`,
        saveTimeTable: `${apiURL}/api/time-table/save.php`,

        // Attendance Configuration 
        addAttendanceConfiguration: `${apiURL}/api/attendance/configuration/create.php`,
        attendanceConfigurationList: `${apiURL}/api/attendance/configuration/list.php`,

        // Fee Configuration 
        createFeeType: `${apiURL}/api/fee/types/create.php`,
        fetchFeeTypes: `${apiURL}/api/fee/types/list.php`,
        fetchAcademics: `${apiURL}/api/fee/academics.php`,
        createFeeConfiguration: `${apiURL}/api/fee/configuration/create.php`,
        fetchFeeConfigurations: `${apiURL}/api/fee/configuration/list.php`,
        fetchFeeCollectionList: `${apiURL}/api/fee/collection/list.php`,
        fetchFeeCollectionStudentList: `${apiURL}/api/fee/collection/students.php`,
        fetchStudentFeeDetails: `${apiURL}/api/fee/collection/student-details.php`,

        // Discount 
        insertFeeDiscount: `${apiURL}/api/fee/discount/insert.php`,
        fetchFeeDiscounts: `${apiURL}/api/fee/discount/list.php`,

        //Bank Accounts
        addBankAccount: `${apiURL}/api/bank-account/insert.php`,
        fetchBankAccounts: `${apiURL}/api/bank-account/list.php`,
        splitBankAccount: `${apiURL}/api/bank-account/split-account.php`,
        fetchSplitAccounts: `${apiURL}/api/bank-account/split-list.php`,

        // Communication 
        insertCommunicationMsgTemplate: `${apiURL}/api/communication/message-templates/insert.php`,
        fetchCommunicationMsgTemplates: `${apiURL}/api/communication/message-templates/list.php`,

        // Roles & Permissions
        createUpdateRole: `${apiURL}/api/role-permission/create-edit.php`,
        fetchRoles: `${apiURL}/api/role-permission/list.php`,
        fetchRoleDetails: `${apiURL}/api/role-permission/details.php`,
        deleteRole: `${apiURL}/api/role-permission/delete.php`,

        // Hostel Management
        addHostelBuilding: `${apiURL}/api/hostel/building/insert.php`,
        fetchHostelBuilding: `${apiURL}/api/hostel/building/list.php`,
        addHostelRoom: `${apiURL}/api/hostel/room/insert.php`,
        fetchHostelRoom: `${apiURL}/api/hostel/room/list.php`,
        fetchRoomBeds: `${apiURL}/api/hostel/room/bed-list.php`,
        addHostelResident: `${apiURL}/api/hostel/resident/insert.php`,
        fetchHostelResidents: `${apiURL}/api/hostel/resident/list.php`,

        // Transport
        addVehicle: `${apiURL}/api/transport/vehicles/insert.php`,
        fetchVehicles: `${apiURL}/api/transport/vehicles/list.php`,
        addVehicleStaff: `${apiURL}/api/transport/staffs/insert.php`,
        fetchVehicleStaffs: `${apiURL}/api/transport/staffs/list.php`,
        addStopage: `${apiURL}/api/transport/stopages/insert.php`,
        fetchStopages: `${apiURL}/api/transport/stopages/list.php`,
        fetchStopagesRoutewise: `${apiURL}/api/transport/stopages/routewise-list.php`,
        addRoute: `${apiURL}/api/transport/routes/insert.php`,
        fetchRoutes: `${apiURL}/api/transport/routes/list.php`,
        addPassenger: `${apiURL}/api/transport/passengers/insert.php`,
        fetchPassenger: `${apiURL}/api/transport/passengers/list.php`,

        // Library Management
        addBook: `${apiURL}/api/library/books/insert.php`,
        fetchBooks: `${apiURL}/api/library/books/list.php`,
        addLibraryMember: `${apiURL}/api/library/members/insert.php`,
        fetchLibraryMembers: `${apiURL}/api/library/members/list.php`,
    };
}